export const billingProfileHc = {
  datosFacturacion: {
    titulo: "Datos de facturación",
    requeridos: "Los datos de facturación son requeridos",
  },
  perfil: {
    swalTitle: "Revise su correo",
    swalText:
      "Para continuar con el cambio de contraseña consulte su bandeja de entrada y siga los pasos",
    swalConfirm: "Continuar",
    errorInesperado: "Ups! ocurrió un error inesperado",
  },
  facturacionCuenta: {
    editarInfo: "Editar información",
    direccionLinea1: "Dirección línea 1",
    direccionLinea2: "Dirección línea 2 (opcional)",
    cancelar: "Cancelar",
    guardando: "Guardando...",
    guardarCambios: "Guardar cambios",
    errorCargar: "Error al cargar los datos de facturación",
    actualizadoOk: "Datos actualizados correctamente",
    errorActualizar: "Error al actualizar",
    errorActualizarDatos: "Error al actualizar los datos",
  },
};
